import {Api} from "../config/request";
const saveProfile = async (data) => {
    let response = await Api.PostRequest("/saveUserProfile", data);
    return response.data;
}

const saveProfileImage= async (data) => {
    let response = await Api.PostFileRequest("/saveUserProfileImage", data);
    return response.data;
}

const changeUserPasssword = async (data) => {
    let response = await Api.PostRequest("/changePassword", data);
    return response.data;
}

const changeEmailAddress = async (data) => {
    let response = await Api.PostRequest("/changeEmailAddress", data);
    return response.data;
}

const verifyAndUpdateEmailAddress = async (data) => {
    let response = await Api.PostRequest("/verifyAndUpdateEmailAddress", data);
    return response.data;
}

const changePhoneNumber = async (data) => {
    let response = await Api.PostRequest("/changePhoneNumber", data);
    return response.data;
}

const verifAndUpdateContactNumber = async (data) => {
    let response = await Api.PostRequest("/verifyAndUpdateContactNumber", data);
    return response.data;
}

const updateUser = {
    saveProfile,
    saveProfileImage,
    changeUserPasssword,
    changeEmailAddress,
    verifyAndUpdateEmailAddress,
    changePhoneNumber,
    verifAndUpdateContactNumber,
}
export default updateUser;